var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text send logout",attrs:{"elevation":"2","color":"#e61e30"},on:{"click":_vm.logout}},[_vm._v("Log out")])}
var staticRenderFns = []

export { render, staticRenderFns }